module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/users-profile-dd59979f14f040a120b0520c9f3ef2a6.svg";